import { render, staticRenderFns } from "./TeamPositionsSlide.vue?vue&type=template&id=7e28b0f0"
import script from "./TeamPositionsSlide.vue?vue&type=script&lang=js"
export * from "./TeamPositionsSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports